export default postalOperators => postalOperators
  .filter(postalOperator =>
    postalOperator.mailProcessingCenters && postalOperator.mailProcessingCenters.length)
  .map((postalOperator) => {
    const childrenMailProcessingCenter = postalOperator.mailProcessingCenters
      .map(mailProcessingCenter =>
        ({
          value: mailProcessingCenter.code,
          label: `${mailProcessingCenter.code} - ${mailProcessingCenter.longName
            ? mailProcessingCenter.longName : ''}`,
        }));
    return {
      value: postalOperator.postalOperatorCode,
      label:
          (postalOperator.shortPostalOperatorCode ? `${postalOperator.shortPostalOperatorCode} - ` : '') + (postalOperator.shortName
        ? postalOperator.shortName : ''),
      children: childrenMailProcessingCenter,
    };
  });
